import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'
import ChatbotFeedbackAdmin from '@/views/super-admin/chatbot-feedback'

export const Route = createFileRoute('/_authenticated/super-admin-feedback')({
  beforeLoad: async () => {
    const auth = useAuthStore.getState().auth;
    if (!auth.accessToken || !auth.user) {
      throw redirect({ to: '/auth/login' });
    }
    if (auth.user.role !== 'Super Admin' && auth.user.role_name !== 'Super Admin') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: ChatbotFeedbackAdmin,
})